import { render, staticRenderFns } from "./ButtonsService.vue?vue&type=template&id=7215dbd8&scoped=true&"
import script from "./ButtonsService.vue?vue&type=script&lang=js&"
export * from "./ButtonsService.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsService.vue?vue&type=style&index=0&id=7215dbd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215dbd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
